export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_2-a102708f37a5f67ceb59e73666908081.mp4";